import React from 'react';
import { FadeIn } from './FadeIn';
export function CostComparison() {
  const comparisons = [{
    without: 'Cristales mal pedidos',
    cost: 'Tablas de corte exactas'
  }, {
    without: 'Marcos rombados',
    cost: 'Protocolo de termofusión'
  }, {
    without: 'Filtraciones y reclamos',
    cost: 'Sellado en 4 capas documentado'
  }, {
    without: 'Presupuestos sin ganancia',
    cost: 'Planilla de precio real'
  }, {
    without: 'Ayudante que pregunta todo',
    cost: 'Checklists para trabajar solo'
  }];
  return <section className="py-16 relative" data-id="element-40">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-41">
        <FadeIn data-id="element-42">
          <div className="text-center mb-10" data-id="element-43">
            <div className="text-5xl mb-4" aria-hidden="true" data-id="element-44">
              ⚖️
            </div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-white" data-id="element-45">
              ¿CUÁNTO CUESTA NO TENERLO?
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-46">
          <div className="bg-surface rounded-2xl border border-white/10 overflow-hidden mb-8" data-id="element-47">
            <div className="grid grid-cols-2 bg-surfaceLight p-4 md:p-6 border-b border-white/10" data-id="element-48">
              <div className="font-bold text-gray-400 uppercase tracking-wider text-sm md:text-base" data-id="element-49">
                Sin el Sistema Maestro
              </div>
              <div className="font-bold text-gold uppercase tracking-wider text-sm md:text-base pl-4 md:pl-6 border-l border-white/10" data-id="element-50">
                Con el Sistema Maestro
              </div>
            </div>
            <div className="divide-y divide-white/5" data-id="element-51">
              {comparisons.map((item, i) => <div key={i} className="grid grid-cols-2 p-4 md:p-6 hover:bg-white/[0.02] transition-colors" data-id="element-52">
                  <div className="text-gray-400 pr-4" data-id="element-53">{item.without}</div>
                  <div className="text-gold/90 pl-4 md:pl-6 border-l border-white/5 font-medium" data-id="element-54">
                    {item.cost}
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-55">
          <div className="mt-10 text-center max-w-3xl mx-auto" data-id="element-56">
            <p className="text-xl md:text-2xl text-white font-bold mb-4" data-id="element-57">
              El próximo trabajo puede ser diferente.
            </p>
            <p className="text-lg text-gold italic" data-id="element-58">
              🏗️ "Desde hoy, tu taller de PVC + DVH tiene sistema."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}